import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  LinearProgress,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowForward } from "@material-ui/icons";
import { FormBuilder } from "@zennya/web-component-library/src/components/FormBuilder";
import { ConcentricBadge } from "components/ConcentricBadge";
import { motion } from "framer-motion";
import { debounce, isEmpty } from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { JsonParam, StringParam } from "serialize-query-params";
import corporateHealthService from "services/corporate-health.service";
import { BooleanParam, useQueryParam } from "use-query-params";
import { processHealthPass } from "util/ProcessHealthPass";
import { slideRight, slideUp } from "util/transitions";
import * as Yup from "yup";
import v from "voca";
import { useStyles as baseCardStyles } from "../MedicalId/index";

const useStyles = makeStyles((theme) => ({}));

function DependentDetails({relations}) {
  const classes = { ...useStyles(), ...baseCardStyles() };
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const [urlFormValues, setUrlFormValues] = useQueryParam(
    "dependentForm",
    JsonParam
  );
  const [formValues, setFormValues] = useState(urlFormValues);
  const [isDependent, setIsDependent] = useQueryParam(
    "isDependent",
    BooleanParam
  );

  const [relationOptions, setRelationOptions] = useState(relations);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const backButtonProps = {
    variant: isMobile ? "text" : "contained",
  };

  const debounceParams = useCallback(
    debounce(
      (values) => {
        setUrlFormValues(values, "replaceIn");
      },
      250,
      { maxWait: 500 }
    ),
    []
  );

  useEffect(() => {
    debounceParams(formValues);
  }, [debounceParams, formValues, setUrlFormValues]);

  const form = useMemo(() => {
    return {
      primaryEmployeeId: {
        type: "text",
        label: "Input Corporate ID Number",
        initialValues: formValues?.primaryEmployeeId ?? "",
        validator: () => Yup.string().required().nullable().label(" "),
        readOnly: formValues?.primaryEmployeeId,
        fieldProps: {
          className: formValues?.primaryEmployeeId
            ? classes.prefilled
            : classes.default,
        },
      },
      dependentRelationship: {
        type: "select",
        label: "Relationship",
        initialValues: formValues?.dependentRelationship ?? "",
        options: relationOptions ?? [],
        settings: {
          default: "",
          multiple: false,
          labelField: "label",
          valueField: "value",
        },
        // readOnly: formValues?.dependentRelationship,
        // fieldProps: {
        //   className: formValues?.dependentRelationship
        //     ? classes.prefilled
        //     : classes.default,
        // },
        validator: () => Yup.string().required().nullable().label(" "),
      },
    };
  }, [
    classes.default,
    classes.prefilled,
    formValues?.primaryEmployeeId,
    formValues?.dependentRelationship,
    relationOptions,
  ]);

  const formLayout = ["primaryEmployeeId", "dependentRelationship"];

  async function handleSubmit() {
    console.log("📢[index.js:157]:", "handleSubmit");
    history.push({
      pathname: "/onboarding/basicinfo",
      search: location.search,
    });
  }

  return (
    <Container fixed maxWidth="md" className={classes.cardInset}>
      <Box className={classes.headerContainer}>
        <ConcentricBadge number={3} />
        <span className={classes.header}>Dependent Details</span>
      </Box>
      <Card className={classes.card}>
        <CardContent>
          <FormBuilder
            formId="dependentForm"
            // usePersist
            onChange={(values) => {
              setFormValues(values);
            }}
            variant="outlined"
            formLabel=" "
            submitLabel={
              <>
                Next <ArrowForward fontSize="small" />
              </>
            }
            formFactor="default"
            hasReset={false}
            formLayout={formLayout}
            form={form}
            onSubmit={(values) => {
              console.log("📢[index.js:101 form submit]:", values);
              handleSubmit();
            }}
            additionalActions={() => (
              <Button
                {...backButtonProps}
                onClick={() => {
                  history.goBack();
                }}
              >
                Back
              </Button>
            )}
          />
        </CardContent>
      </Card>
    </Container>
  );
}

export default function DependentDetailsLoader() {
  const [loading, setLoading] = useState(true);
  const [hashId, setHashId] = useQueryParam("code", StringParam);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const [urlFormValues, setUrlFormValues] = useQueryParam(
    "dependentForm",
    JsonParam
  );
  const [isDependent, setIsDependent] = useQueryParam(
    "isDependent",
    BooleanParam
  );
  const [relationOptions, setRelationOptions] = useState([]);

  useEffect(() => {
    async function fetchHealthPass() {
      const healthPass = await processHealthPass(hashId);
      if (isEmpty(urlFormValues)) {
        setIsDependent(healthPass?.dependentDetails?.isDependent, "replaceIn");
        setUrlFormValues(healthPass?.dependentDetails, "replaceIn");
      }
      setRelationOptions(
        (
          (await corporateHealthService.getRelationOptions())?.data?.list ?? []
        ).map((i) => {
          return {
            label: v.capitalize(i, true),
            value: i,
          };
        })
      );
      setLoading(false);
    }
    fetchHealthPass();
  }, [hashId, setIsDependent, setUrlFormValues, urlFormValues]);

  if (loading) {
    return <LinearProgress />;
  }
  return (
    <motion.div {...(isMobile ? slideRight : slideUp)}>
      <DependentDetails relations={relationOptions} loading={loading}/>
    </motion.div>
  );
}
